import React from "react";
import { FaAddressBook } from "react-icons/fa";
import { MdFormatListBulleted, MdPersonAddAlt1 } from "react-icons/md";
import CrmListPage from "components/app/crm/shared/CrmListPage";
import { columnDefs as baseColumns } from "./component/Columns";
import { getAllContacts, getCreatedFromLeadContacts, exportContacts } from "redux/crm/contactSlice";

// field -> server sort attribute (ransackable). Other columns are not sortable.
const SORTABLE = {
  contact_code: "id", first_name: "first_name", last_name: "last_name",
  email: "email", mobile: "mobile", position: "position",
  department: "department", created_at: "created_at", updated_at: "updated_at"
};

const columns = baseColumns.map((c) =>
  SORTABLE[c.field] ? { ...c, colId: SORTABLE[c.field], sortable: true } : { ...c, sortable: false }
);

const ADVANCED_FIELDS = [
  { key: "id",                label: "Contact ID#",     type: "text", paramKey: "id_cont",                        tagName: "ID#" },
  { key: "name",              label: "Contact name",    type: "text", paramKey: "first_name_or_last_name_cont",   tagName: "Name", pinned: true, minWidth: 130, flex: 0, width: 190 },
  { key: "email",             label: "Email",           type: "text", paramKey: "email_cont",                     tagName: "Email" },
  { key: "mobile",            label: "Mobile",          type: "text", paramKey: "mobile_cont",                    tagName: "Mobile" },
  { key: "position",          label: "Position",        type: "text", paramKey: "position_cont",                  tagName: "Position" },
  { key: "department",        label: "Department",      type: "text", paramKey: "department_cont",                tagName: "Dept" },
  { key: "main_contact",      label: "Main contact",    type: "text", paramKey: "main_contact_cont",              tagName: "Main" },
  { key: "secondary_contact", label: "Secondary contact", type: "text", paramKey: "secondary_contact_in",         tagName: "Secondary" },
  { key: "company_name",      label: "Company",         type: "text", paramKey: "company_name_cont",              tagName: "Company" },
  { key: "lead_name",         label: "Lead",            type: "text", paramKey: "lead_name_cont",                 tagName: "Lead" }
];

const TABS = [
  { key: "all",       label: "All",               Icon: MdFormatListBulleted, thunk: getAllContacts,            dataKey: "allData" },
  { key: "from_lead", label: "Created from Lead", Icon: MdPersonAddAlt1,       thunk: getCreatedFromLeadContacts, dataKey: "createdFromLeadData" }
];

const ContactListPage = () => (
  <CrmListPage
    title="Contacts"
    subtitle="List of contacts."
    Icon={FaAddressBook}
    reducerSelector={(s) => s.crm_contact}
    tabs={TABS}
    columns={columns}
    defaultSort={{ attribute: "id", direction: "DESC" }}
    searchParamKey="id_or_first_name_or_last_name_or_mobile_or_email_cont"
    searchPlaceholder="ID#, name, mobile, email..."
    dateFilters={[{ key: "created", label: "Created date", paramKeys: ["created_date_gteq", "created_date_lteq"], defaultThisMonth: true }]}
    showSalesUnit
    advancedFields={ADVANCED_FIELDS}
    advancedTitle="Filters for contacts"
    advancedDescription="Establish the contact's filtering criteria"
    exportThunk={exportContacts}
  />
);

export default ContactListPage;
